
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewsRecipient_userInterfaceDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userInterfaceDetails"},"name":{"kind":"Name","value":"risolto_participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participant"}}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contact_allow_edit"},"name":{"kind":"Name","value":"user_interface_details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"contact.allow_edit","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"recipient_allow_edit"},"name":{"kind":"Name","value":"user_interface_details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"recipient.allow_edit","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"custom_field_definitions"},"name":{"kind":"Name","value":"user_interface_details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"recipient.custom_field_definitions","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"credit_note_custom_field_definitions"},"name":{"kind":"Name","value":"user_interface_details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"credit_note.custom_field_definitions","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"debit_note_custom_field_definitions"},"name":{"kind":"Name","value":"user_interface_details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"debit_note.custom_field_definitions","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"payment_document_custom_field_definitions"},"name":{"kind":"Name","value":"user_interface_details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"payment_document.custom_field_definitions","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"use_accounting_documents_table"},"name":{"kind":"Name","value":"user_interface_details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"recipient.use_accounting_documents_table","block":false}}],"directives":[]}]}}]}}],"loc":{"start":0,"end":857}};
    doc.loc.source = {"body":"query ViewsRecipient_userInterfaceDetails($participant: uuid!) {\n\tuserInterfaceDetails: risolto_participant(\n\t\twhere: {\n\t\t\treference: { _eq: $participant }\n\t\t}\n\t) {\n\t\tcontact_allow_edit: user_interface_details(path: \"contact.allow_edit\")\n\t\trecipient_allow_edit: user_interface_details(path: \"recipient.allow_edit\")\n\t\tcustom_field_definitions: user_interface_details(path: \"recipient.custom_field_definitions\")\n\t\tcredit_note_custom_field_definitions: user_interface_details(path: \"credit_note.custom_field_definitions\")\n\t\tdebit_note_custom_field_definitions: user_interface_details(path: \"debit_note.custom_field_definitions\")\n\t\tpayment_document_custom_field_definitions: user_interface_details(path: \"payment_document.custom_field_definitions\")\n\t\tuse_accounting_documents_table: user_interface_details(path: \"recipient.use_accounting_documents_table\")\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ViewsRecipient_userInterfaceDetails"] = oneQuery(doc, "ViewsRecipient_userInterfaceDetails");
        
